import { Box, Container, Heading, Table, TableCaption, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import { NextPage } from 'next'
import groupBy from 'lodash.groupby'
import SEO from 'components/SEO'
import sortBy from 'lodash.sortby'

type Price = Record<string, any>

interface PricingProps {
  prices: Price[]
}

const Pricing: NextPage<PricingProps> = ({ prices }) => {
  const sanitizedPrices = prices.map((price) => {
    const speciality = price.attributes.speciality.data
    return {
      id: price.id,
      ...price.attributes,
      speciality,
      specialityPriority: speciality?.attributes?.displayPriority
    }
  })
  const filteredPrices = sanitizedPrices.filter((price) => !!price?.speciality?.attributes?.name)
  const grouppedPrices = groupBy(filteredPrices, 'speciality.attributes.name')
  const pricesLists = Object.entries(grouppedPrices)
  const sortedLists = sortBy(pricesLists, '[1][0].specialityPriority').reverse()

  return (
    <Container maxWidth="container.xl" marginY="3rem">
      <SEO
        title="Cennik usługi, zabiegi, badania przychodnia medyczna Poznań"
        description="Cennik zabiegów medycznych i konsultacji lekarskie laryngologia, ortopedia, logopedia, chirurgia, rehabilitacja. Medwind prywatna przychodnia medyczna Poznań. "
      />
      <Heading as="h1" size="lg">
        Cennik badań, zabiegów medycznych - Medwind Poznań
      </Heading>
      {sortedLists?.map(([group, prices]) => {
        const listTitle = prices?.[0]?.speciality?.attributes?.pricingTitle
        return (
          <Box key={group}>
            <Heading size="md" marginTop="2rem">
              {listTitle}
            </Heading>
            <Table marginTop="1rem">
              <TableCaption fontWeight="bold">
                Wszystkie procedury medyczne oraz usługi nie ujęte w cenniku wycenia indywidualnie lekarz lub
                specjalista w trakcie konsultacji.
              </TableCaption>
              <Thead>
                <Tr>
                  <Th>Usługa</Th>
                  <Th>Cena</Th>
                </Tr>
              </Thead>
              <Tbody>
                {prices?.map((price) => {
                  const prices = price.prices?.data
                  const sortedPrices = sortBy(prices, 'attributes.createdAt')
                  return (
                    <>
                      <Tr key={price.id}>
                        <Td width="75%">{price.label}</Td>
                        <Td width="25%">{price.amount}</Td>
                      </Tr>
                      {sortedPrices?.map((nestedPrice: any) => (
                        <Tr key={nestedPrice.id}>
                          <Td width="75%">•&nbsp;&nbsp;&nbsp;{nestedPrice.attributes.label}</Td>
                          <Td width="25%">{nestedPrice.attributes.amount}</Td>
                        </Tr>
                      ))}
                    </>
                  )
                })}
              </Tbody>
            </Table>
          </Box>
        )
      })}
    </Container>
  )
}

export async function getServerSideProps() {
  const URL = `${process.env.NEXT_PUBLIC_API_URL}/api/prices?populate=speciality,prices&pagination[pageSize]=200`
  const res = await fetch(URL)
  const { data } = await res.json()
  return { props: { prices: data } }
}

export default Pricing
